import React, { FC, useState } from 'react';
import { Moment } from 'moment';
import type { SelectOptionType } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { Button } from '@common/components';
import { CategoriesPicker } from '../Filters/CategoriesPicker';
import { DatePicker } from '../Filters/DatePicker';
import {
  FiltersWrapper,
  ClassFiltersWrapper,
  ButtonClassFiltersColumn,
} from '../Filters/Filters.styles';
import { MobileModal } from '../MobileModal';

type DateCategoryPickerProps = {
  fromDate: Moment;
  onDateChange: (date: Moment) => void;
  categories: SelectOptionType[];
  onCategoryChange: (SelectOptionType) => void;
  selectedCategory?: SelectOptionType;
  handleUpdate: () => void;
};

export const DateCategoryPicker: FC<DateCategoryPickerProps> = ({
  fromDate,
  onDateChange,
  categories,
  onCategoryChange,
  selectedCategory,
  handleUpdate,
}) => {
  const { t } = useTranslations();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleMobileUpdate = () => {
    setIsModalOpen(false);
    handleUpdate();
  };
  return (
    <MobileModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
      <FiltersWrapper>
        <ClassFiltersWrapper>
          <DatePicker showDatesPicker fromDate={fromDate} onDateChange={onDateChange} />
          <CategoriesPicker
            categories={categories}
            onCategoryChange={onCategoryChange}
            selectedCategory={selectedCategory}
            showCategoriesPicker
          />
          <ButtonClassFiltersColumn>
            <Button isInline onClick={() => handleMobileUpdate()}>
              {t('spaClasses.update')}
            </Button>
          </ButtonClassFiltersColumn>
        </ClassFiltersWrapper>
      </FiltersWrapper>
    </MobileModal>
  );
};
